import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { CenteredSpinner } from '../../components/ui/Spinner';
import { getCampaign } from './api';
import { CampaignForm } from './CampaignForm';

export function CampaignEdit() {
  const { id } = useParams<{ id: string }>();
  const query = useQuery({
    queryKey: ['campaign', id],
    queryFn: () => getCampaign(id!),
    enabled: !!id,
  });

  if (query.isLoading) return <CenteredSpinner />;
  if (query.error || !query.data) {
    return (
      <div className="text-red-600 text-sm">
        Failed to load campaign: {(query.error as Error | undefined)?.message ?? 'not found'}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-slate-900">Edit campaign</h1>
      <CampaignForm mode={{ kind: 'edit', campaign: query.data }} />
    </div>
  );
}
